export enum MetadataTableType {
    VIEW = "VIEW",
    MATERIALIZED_VIEW = "MATERIALIZED_VIEW",
    GENERATED_COLUMN = "GENERATED_COLUMN"
}
